import { DatePickerMonth } from "./data-picker-month";
import { Range } from "./range";
import { DatepickerService } from "./datepicker.service";
import { Settings } from "../setting";
export class Datepicker {
    val: string = "";
    month: Array<DatePickerMonth> = [new DatePickerMonth('January', 'datepicker-list-line'),
    new DatePickerMonth('February', ''),
    new DatePickerMonth('March', 'datepicker-list-line'),
    new DatePickerMonth('April', ''),
    new DatePickerMonth('May', 'datepicker-list-line'),
    new DatePickerMonth('June', ''),
    new DatePickerMonth('July', 'datepicker-list-line'),
    new DatePickerMonth('August', ''),
    new DatePickerMonth('September', 'datepicker-list-line'),
    new DatePickerMonth('October', ''),
    new DatePickerMonth('November', 'datepicker-list-line'),
    new DatePickerMonth('December', '')
    ];
    week: Array<string> = [
        'Aug 1 — Aug 6',
        'Aug 7 — Aug 13',
        'Aug 14 — Aug 20',
        'Aug 21 — Aug 27',
        'Aug 28 — Aug 31',
    ];
    years: Array<number> = [new Date().getFullYear() - 2, new Date().getFullYear() - 1, new Date().getFullYear(), new Date().getFullYear() + 1];
    range: Array<Range> = [];
    constructor() {

    }
    public updateMonths (settings:Settings,action:DatepickerService) {
        if (settings.viewType === 'monthsOfYear') {
            this.month = action.DefaultMonth();
        }
        else {
            this.month[settings.month - 1].class = 'datepicker-list-select';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/datepicker/datepicker.ts